import {Message} from "./message";

export class ArrivalTimeChanged implements Message {
  constructor(public freighterId: number,
              public orderId: number,
              public draftId: number,
              public time: string,
              public text?: string) {}
}